enum UploadManagerStatus {
  SUCCESS_UPLOAD_CAN_START = "success_upload_can_start",
  SUCCESS_UPLOAD_COMPLETE = "success_upload_complete",
  ERROR_UPLOAD_FAILED = "error_upload_failed",
  ERROR_UPLOAD_IN_PROGRESS = "error_upload_in_progress",
  ERROR_ALL_FILES_PROCESSED = "error_all_files_processed",
  ERROR_NO_FILES_TO_UPLOAD = "error_no_files_to_upload",
}

export default UploadManagerStatus;
